import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FormWorkflowState } from '../states/formWorkflowState';

const selectFormState = createFeatureSelector<FormWorkflowState>('form');

export const selectSendContentById = (id: number) => createSelector(
  selectFormState,
  (formState: FormWorkflowState) => formState.sendContents[id]
);
